var map = {
	"./baac.svg": "5671",
	"./bay.svg": "aa82",
	"./bbl.svg": "b91c",
	"./bnp.svg": "653f",
	"./boa.svg": "81cd",
	"./cacib.svg": "7bf0",
	"./cimb.svg": "3c69",
	"./citi.svg": "a931",
	"./db.svg": "bde3",
	"./ghb.svg": "e1f4",
	"./gsb.svg": "3f6b",
	"./hsbc.svg": "31d4",
	"./ibank.svg": "cfec",
	"./icbc.svg": "aa9c",
	"./jpm.svg": "8054",
	"./kbank.svg": "7f96",
	"./kk.svg": "d1f5",
	"./ktb.svg": "634b",
	"./lhb.svg": "62a3",
	"./mb.svg": "9ef2",
	"./mega.svg": "fbcf",
	"./mufg.svg": "97ef",
	"./rbs.svg": "5c52",
	"./sc.svg": "56b8",
	"./scb.svg": "3191",
	"./smbc.svg": "452a",
	"./tbank.svg": "3c52",
	"./tcrb.svg": "2c8a",
	"./tisco.svg": "37e5",
	"./tmb.svg": "2c3d",
	"./truemoney.svg": "edc9",
	"./ttb.svg": "171b",
	"./uob.svg": "1f63"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0d84";